import React, { useEffect, useState } from "react";

export const isPostHistory = (post) => ["CANCELLED", "CANCELED", "PUBLISHED"].includes(post.status);

export default function AdminPostList({ posts, children }) {
  const [view, setView] = useState("active");
  const [query, setQuery] = useState("");
  const [page, setPage] = useState(1);
  const historyCount = posts.filter(isPostHistory).length;
  const filtered = posts.filter((post) => (view === "all" || (view === "history" ? isPostHistory(post) : !isPostHistory(post))) &&
    [post.caption, post.itemName, post.campaignName, post.platform, post.status].filter(Boolean).join(" ").toLowerCase().includes(query.trim().toLowerCase()));
  const pages = Math.max(1, Math.ceil(filtered.length / 10));
  const current = Math.min(page, pages);
  useEffect(() => { setPage(1); }, [query, view]);
  return <div className="admin-post-list">
    <div className="admin-list-tools">
      <div className="admin-list-views" role="group" aria-label="Post list view">{[
        ["active", `Active queue (${posts.length - historyCount})`],
        ["history", `History (${historyCount})`],
        ["all", `All posts (${posts.length})`],
      ].map(([value, label]) => <button key={value} type="button" aria-pressed={view === value} onClick={() => setView(value)}>{label}</button>)}</div>
      <label>Find a post<input aria-label="Search posts" type="search" placeholder="Campaign, caption, platform or status" value={query} onChange={(event) => setQuery(event.target.value)} /></label>
    </div>
    <p className="admin-list-summary" role="status">{filtered.length} matching posts. {view === "active" ? "Published and canceled posts are kept in history." : "History is retained; nothing is deleted."}</p>
    <div className="space-y-3">{filtered.slice((current - 1) * 10, current * 10).map(children)}</div>
    {!filtered.length && <p className="admin-list-empty">{view === "active" && !query ? "No active posts. Choose history to review past activity." : "No posts match these filters."}</p>}
    {pages > 1 && <nav className="admin-list-pagination" aria-label="Post pages"><button type="button" disabled={current === 1} onClick={() => setPage(current - 1)}>Previous</button><span>Page {current} of {pages}</span><button type="button" disabled={current === pages} onClick={() => setPage(current + 1)}>Next</button></nav>}
  </div>;
}
